import * as React from "react";
import { useTranslation } from "react-i18next";
import { useGetPriorities } from "security-app/hooks/useInvestigationsAPI";
import { Spinner } from "components/common";
const PriorityValue = ({ priorityId }) => {
  const { t } = useTranslation("enterprise_security_investigations");
  const { priorities, loadingPriorities } = useGetPriorities();
  if (loadingPriorities) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  const priority = priorities.find(({ priority: p }) => priorityId === String(p));
  if (priority) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, priority.text);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, t("widget_filters.unknown"));
};
export default PriorityValue;
